import React from 'react';
import { useTranslation } from 'react-i18next';
import { FarecardPass } from '../../services/types/apitypes';
import { IonButton } from '@ionic/react';
import CardPassItem from './CardPassItem';

type CardPassesListProps = {
  passes: FarecardPass[];
  add: () => void;
};

export default function CardPassesList({ passes, add }: CardPassesListProps) {
  const [t] = useTranslation('global');

  return (
    <>
      <h1 className="h1 h1plus ion-text-center">{t('cardpasses.title')}</h1>
      <p className="pt-2 pb-3 instructions ion-text-center">
        {t('cardpasses.info')}
      </p>

      {passes &&
        passes.map((pass: FarecardPass, i: number) => {
          return (
            <CardPassItem
              key={i}
              title={pass.name}
              statusColor={pass.isActive ? 'green' : 'grey'}
              isActive={pass.isActive}
              validityDescription={pass.validTo}
              activateUntil={pass.activateUntil}
            />
          );
        })}

      <div className="pt-3 ion-text-center">
        <IonButton className="btn-default btn-wide-80" onClick={() => add()}>
          {t('cardpasses.add')}
        </IonButton>
      </div>
    </>
  );
}
